import { BULK_EDIT_CAP } from '@ooh/contracts';

/**
 * A filter-based selection ("select all N matching") has no id list on the
 * client to cap-check against `selectedCount` — only `totalMatching` applies.
 * An id-based selection has no server-resolved total — only its own length
 * can exceed the cap. Shared by every catalog bulk action (edit, delete,
 * recompute-location, mark-availability) so the id-based cap check newly
 * reachable once selection persists across search/filter/sort (row-selection
 * spec) is applied consistently instead of four bespoke inline conditions.
 */
export function isBulkSelectionCapExceeded(
  isFilterSelection: boolean,
  totalMatching: number,
  selectedCount: number,
): boolean {
  return isFilterSelection ? totalMatching > BULK_EDIT_CAP : selectedCount > BULK_EDIT_CAP;
}

/**
 * A filter-based selection covers every matching unit by definition, so it
 * has no "hidden" units to report; the hidden-count line only ever applies to
 * an id-based selection with a nonzero hidden count.
 */
export function shouldShowHiddenCount(isFilterSelection: boolean, hiddenCount: number): boolean {
  return !isFilterSelection && hiddenCount > 0;
}
